import {Grid} from '@mantine/core';
import {IAgentReview} from '../../../api/AgentSignup/AgentSignup.types';
import Descriptions from '../../common/Descriptions/Descriptions';
import StringUtils from "../../../utils/string.utils";
import AgentReviewFormConversions, {
    AgentReviewFormExclusions
} from "../../../containers/Agent.review.form/Agent.review.form.conversions";


interface Props {
    agentData: IAgentReview
}

function AgentReviewTable({agentData}: Props) {
    function renderDescriptionsData() {
        let ret: any = [];
        Object.keys(agentData).forEach(field => {
            let value = (agentData as any)[field]
            let conversion = AgentReviewFormConversions[field];
            let curDescription = {
                title: StringUtils.convert.camelCase.toSentenceCase(field),
                value: value || "N/A",
            }
            if (conversion) {
                if (conversion.display) {
                    curDescription.title = conversion.display;
                }
                if (conversion.render) {
                    curDescription.value = conversion.render(value)
                }
            }
            if (AgentReviewFormExclusions.indexOf(field) === -1) {
                ret.push(curDescription);
            }
        })
        return ret;
    }

    return (
        <Descriptions data={renderDescriptionsData()}/>
    )
}

export default AgentReviewTable;